module.exports = __webpack_public_path__ + "img/gardeshgari.f5856ad9.png";